import React, { Fragment, useEffect, useState } from "react";
import DataTable from "../../../Common/Components/DataTable";
import {
  GetData,
  DeleteData,
  DataSearch,
  EditData,
  BanUser,
  getTemporary,
} from "./Components/Services";
import Loading from "../../../Common/Components/Loading";
import { Helmet } from "react-helmet";
import CustomModal from "../../../Common/Components/Modal/CustomModal";
import CommonFrom from "../../../Common/Components/Form";
import { input } from "./Create";
import toast from "react-hot-toast";
function List() {
  const initialState = {
    loading: false,
    data: {
      data: null,
      current_page: null,
    },
    modal: false,
  };
  const [searchType, setsearchType] = useState("fullname");
  const [state, setstate] = useState(initialState);

  useEffect(() => {
    Handler();
  }, []);

  const Handler = (pageNumber = 1, limit, index) => {
    setstate({ ...state, loading: true });
    GetData(pageNumber, limit, index).then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };

  const HandlerDelete = data => {
    setstate({ ...state, loading: true });
    DeleteData(data).then(() => {
      GetData().then(result => {
        setstate({
          loading: false,
          data: result,
        });
      });
    });
  };

  const HandelUser = data => {
    setstate({ ...state, loading: true });
    BanUser(data).then(() => {
      GetData().then(result => {
        setstate({
          loading: false,
          data: result,
        });
      });
    });
  };

  const HandlerSearch = data => {
    setstate({ ...state, loading: true });
    DataSearch({ [searchType]: data }).then(data => {
      setstate({
        loading: false,
        data: data,
      });
    });
  };
  const HandlerEdit = data => {
    setstate({ ...state, loading: true });
    EditData({
      ...data,
      client_id:
        state.data &&
        state.data.data &&
        state.data.data
          .filter(user => user.id == state.modal)
          .filter(Boolean)[0].id,
    }).then(() => {
      GetData().then(result => {
        setstate({
          loading: false,
          data: result,
        });
      });
    });
  };
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست مجموعه ها</title>
      </Helmet>

      <DataTable
        loading={state.loading}
        heads={[
          {
            title: "نام و نام خانوادگی",
            key: "fullname",
          },
          // {
          //   title: "ایمیل",
          //   key: "email",
          // },
          {
            title: "موبایل",
            key: "mobile",
          },
          {
            title: "جنسیت",
            key: "gender",
            type: "enum",
            enum: {
              woman: "خانم",
              man: "آقا",
              null: "ثبت نشده",
            },
          },
          {
            title: "کد ملی",
            key: "national_code",
          },
          {
            title: "وضعیت کاربر",
            key: "status",
            type: "enum",
            enum: {
              active: "فعال",
              dactive: "غیرفعال",
              notpassword: "فعال ",
            },
          },
          {
            title: "تعداد سفارش",
            key: "orders_count",
          },
          {
            title: "زمان ثبت اطلاعات",
            key: "created_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        textEmpty="کاربری ثبت نشده"
        list={state.data && state.data.data}
        data={state.data}
        search={HandlerSearch}
        function={Handler}
        currentPage={state.data && state.data.current_page}
        header=" لیست اطلاعات کاربران"
        textbtn="ثبت اطلاعات کاربر"
        linkbtn="/Admin/User/Create"
        links={[
          {
            function: selected => {
              HandlerDelete({ client_id: selected[0] });
            },
            color: "danger",
            size: "col-md-2",
            html: "حذف",
            multi: true,
            type: "delete",
          },
          {
            function: selected => {
              setstate({ ...state, modal: selected[0] });
            },
            color: "info",
            type: "key",
            size: "col-md-2",
            html: "ویرایش",
            type: "edit",
            main: true,
          },
          {
            function: selected => {
              HandelUser({ client_id: selected[0] });
            },
            color: "info",
            size: "col-md-3",
            html: "تغییر وضعیت",
            type: "toggle",
          },
          {
            function: selected => {
              setstate({
                ...state,
                temporary: selected[0],
                user:
                  state.data &&
                  state.data.data &&
                  state.data.data.filter(d => d.id == selected[0])[0],
              });
            },
            color: "info",
            size: "col-md-3",
            html: "رمز عبور موقت",
            type: "go",
          },
        ]}
      />

      <CustomModal
        show={state.modal}
        handleClose={() => {
          setstate({ ...state, modal: false });
        }}
        header={"ویرایش اطلاعات کاربر"}
      >
        <CommonFrom
          loading={state.loading}
          form={input}
          btnName={"ثبت اطلاعات کاربر"}
          value={
            state.data &&
            state.data.data &&
            state.data.data
              .filter(user => user.id == state.modal)
              .filter(Boolean)[0]
          }
          edit={true}
          submit={HandlerEdit}
        />
      </CustomModal>

      <CustomModal
        show={state.temporary}
        handleClose={() => {
          setstate({ ...state, temporary: false });
        }}
        header={"رمز عبور موقت"}
      >
        <SetTemporary state={state} setstate={setstate} />
      </CustomModal>
    </Fragment>
  );
}
const SetTemporary = ({ state, setstate }) => {
  const [passowrd, setPassowrd] = useState(false);
  const [loading, setLoading] = useState(false);
  const handler = async () => {
    setLoading(true);
    await getTemporary({ mobile: state.user.mobile }).then(res => {
      setPassowrd(res);
      setLoading(false);
    });
  };
  return (
    <div>
      <div>
        <p style={{ textAlign: "center", fontWeight: "400" }}>
          پشتیبان محترم زمان استفاده از رمز عبور موقت ۱۰ دقیقه میباشد
        </p>
      </div>
      <div className="d-flex justify-content-center">
        {passowrd ? (
          <button
            className="btn btn-success"
            onClick={() => {
              navigator.clipboard.writeText("admin-" + passowrd.password);
              toast.success("کپی شد");
            }}
          >
            {`admin-${passowrd.password}`}
          </button>
        ) : (
          <button
            className="btn btn-primary"
            disabled={loading}
            onClick={handler}
          >
            {loading ? "در حال ارسال" : "درخواست رمز عبور موقت"}
          </button>
        )}
      </div>
    </div>
    // admin-2092573
  );
};
export default List;
